module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "package.27c9544a.png" + "?" + Date.now();